export default __webpack_public_path__ + "static/media/UdunkuluModalLogo.8f4b8f63.svg";